import { render, staticRenderFns } from "./NieuwsPoster.vue?vue&type=template&id=6c502b82&"
import script from "./NieuwsPoster.vue?vue&type=script&lang=js&"
export * from "./NieuwsPoster.vue?vue&type=script&lang=js&"
import style0 from "./NieuwsPoster.vue?vue&type=style&index=0&id=6c502b82&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports